module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "SERIES1"
  }, [_vm._v("Published Volumes")]), _vm._v(" "), _c('p', {
    staticClass: "SERIES2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Election of Grace: A Riddle without a Resolution?")]), _c('br'), _vm._v("Stephen N. Williams")]), _vm._v(" "), _c('p', {
    staticClass: "SERIES2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The God We Worship: An Exploration of Liturgical Theology")]), _c('br'), _vm._v("Nicholas Wolterstorff")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e51fae5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wolterstorff_The_God_We_Worship_text_CC-1.vue
// module id = 60
// module chunks = 0